/* PagingWorkTrigFutureFeed.js */

const PagingFeed = require("../../../../lib/PagingFeed");

class PagingWorkTrigFutureFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startRelatedFuturesFeed(this._filter, this._entityFields, this._sort, { skip: 0, limit: this._pageSize * 2 });
    }

    _feedReestablish() {
        return this._feed.reestablishFeed(this._userSession.activeOrganization.id, this._filter, this._entityFields, this._sort);
    }

    _feedShutDown() {
        return this._EntityDef.stopRelatedFuturesFeed();
    }
}

module.exports = PagingWorkTrigFutureFeed;
